import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { Box, Button, Grid, Typography } from '@blueprint/ui';
import { axiosInstance } from '../../functions/axios';

import SingleSelection from './SingleSelection';
import MultipleSelection from './MultipleSelection';
import multiplePaymentsColumns from '../PaymentBankDetails/multiplePaymentsColumns';
import CustomerLogo from '../CustomerLogo/CustomerLogo';

const VerifyDetailsConfirmPlaceholder = styled.div`
    padding-top: 100px;
    padding-right: 5vw;
    padding-left: 5vw;
    padding-bottom: 5em;
`;

const VerifyDetailsConfirm = ({ location }) => {
    const history = useHistory();
    const { t } = useTranslation();

    // To check if user is logged in, Throw out if not logged in
    const globalState = useSelector((state) => state);
    const footerHeight = globalState.beneDetails.footerHeight;

    useEffect(() => {
        if (!globalState.beneDetails.details.isLogged) {
            history.push('/');
        }
    }, [globalState, history]);

    // URLs for API Calls
    const FETCH_ENRICHEMENT_DETAILS_URL = process.env.REACT_APP_FETCH_ENRICHEMENT_DETAILS_URL;

    const CONFIRM_ENRICHEMENT_DETAILS_URL = process.env.REACT_APP_CONFIRM_ENRICHEMENT_DETAILS_URL;

    // Local State of Component
    // const [state, _dispatch] = useReducer(reducer, initialState);

    const [enrichmentDetails, setEnrichmentDetails] = useState(null);
    const [showFxRate, setShowFxRate] = useState(false);
    const [showAddress, setShowAddress] = useState(false);
    const [showPaypalEmail, setShowPaypalEmail] = useState(false);
    const [showBankDetails, setShowBankDetails] = useState(false);
    const [singleSelection, setSingleSelection] = useState(true);
    const [transactions, setTransactions] = useState([]);

    // API Call to fetch Enrichment Details
    useEffect(() => {
        const getEnrichmentDetails = async () => {
            const response = await axiosInstance.post(
                FETCH_ENRICHEMENT_DETAILS_URL,
                JSON.stringify({
                    // emailId: globalState.beneDetails.details.emailId,
                    stagePaymentId: location.state.stagePaymentId,
                })
            );
            if (response) {
                if (response.status === 200) {
                    const responseJson = response.data;
                    console.log('Logging FETCH_ENRICHEMENT_DETAILS response', response.data);
                    setTransactions(responseJson.transactions);
                    setEnrichmentDetails(responseJson);

                    if (responseJson.addressDisplayValue != null) {
                        setShowAddress(true);
                    }
                    if (responseJson.fxRate !== null && responseJson.transactionType === 'FIXED_DEBIT') {
                        setShowFxRate(true);
                    }

                    if (responseJson.wallet !== null) {
                        setShowPaypalEmail(true);
                    }

                    if (responseJson.bankDisplayValue !== null) {
                        setShowBankDetails(true);
                    }

                    if (responseJson.transactions.length === 1) {
                        setSingleSelection(true);
                    } else {
                        setSingleSelection(false);
                    }
                } else {
                    console.log('Handle Error');
                }
            }
        };
        getEnrichmentDetails();
    }, [FETCH_ENRICHEMENT_DETAILS_URL, globalState.beneDetails.details.emailId, location.state.stagePaymentId]);

    // API Call to send confirmation for Enrichment Details
    const confirmDetails = async () => {
        const response = await axiosInstance.post(
            CONFIRM_ENRICHEMENT_DETAILS_URL,
            JSON.stringify({
                // emailId: globalState.beneDetails.details.emailId,
                stagePaymentId: location.state.stagePaymentId,
            })
        );
        if (response) {
            const responseJson = response.data;
            if (response.status !== 200) {
            } else {
                console.log(responseJson);
                history.push({
                    pathname: '/acknowledgement',
                    state: {
                        stagePaymentId: location.state.stagePaymentId,
                    },
                });
            }
        }
    };

    if (enrichmentDetails !== null) {
        var payerReference = enrichmentDetails.transactions[0].custPaymentRef;
        var payerName = enrichmentDetails.transactions[0].customerName;
        var payerCurrency = enrichmentDetails.transactions[0].instructedCurrency;
        var payerAmount = enrichmentDetails.transactions[0].instructedAmount;
        var payoutCurrency = enrichmentDetails.accountCurrencycode;
        var payoutAmount = enrichmentDetails.totalAmount;
        var fxRate = enrichmentDetails.fxRate;
        if (enrichmentDetails.wallet !== null) {
            var paypalEmail = enrichmentDetails.wallet.walletAccountValue;
        }

        var paymentAddress = enrichmentDetails.addressDisplayValue;
        var paymentDetails = enrichmentDetails.transactions[0].custBeneInfo;

        var coolingOffPeriod = enrichmentDetails.coolingOffPeriod;

        var bankDisplayValue = enrichmentDetails.bankDisplayValue;

        var showTotalPayerAmount = false;
        var totalPayerAmount = 0;
        if (enrichmentDetails.transactions.length > 1 && enrichmentDetails.transactionType === 'FIXED_DEBIT') {
            let total = 0;
            showTotalPayerAmount = true;
            for (let i = 0; i < transactions.length; i++) {
                total += transactions[i].instructedAmount;
            }
            totalPayerAmount = total;
            console.log('Calculated payerAmount is ', totalPayerAmount);
        }
    }

    return (
        <VerifyDetailsConfirmPlaceholder role='main' style={{ paddingBottom: `${footerHeight + 20}px` }}>
            <Grid container xs={12}>
                <CustomerLogo />
                <Grid container>
                    <Box marginBottom={['24px', '24px', '24px', '24px']}>
                        <Box borderLeft='3px solid red' pl='10px'>
                            <Typography variant='h1' className='page-title' tabIndex='-1'>
                                {t('verifyDetailsConfirm.section_title')}
                            </Typography>
                        </Box>
                    </Box>
                </Grid>

                {singleSelection ? (
                    <SingleSelection
                        payerReference={payerReference}
                        payerName={payerName}
                        payerCurrency={payerCurrency}
                        payerAmount={payerAmount}
                        payoutCurrency={payoutCurrency}
                        payoutAmount={payoutAmount}
                        showFxRate={showFxRate}
                        fxRate={fxRate}
                        showPaypalEmail={showPaypalEmail}
                        paypalEmail={paypalEmail}
                        showBankDetails={showBankDetails}
                        bankDisplayValue={bankDisplayValue}
                        showAddress={showAddress}
                        paymentAddress={paymentAddress}
                        paymentDetails={paymentDetails}
                        coolingOffPeriod={coolingOffPeriod}
                    />
                ) : (
                    <MultipleSelection
                        tableData={transactions}
                        columns={multiplePaymentsColumns}
                        payoutAmount={payoutAmount}
                        payoutCurrency={payoutCurrency}
                        showPaypalEmail={showPaypalEmail}
                        paypalEmail={paypalEmail}
                        showBankDetails={showBankDetails}
                        bankDisplayValue={bankDisplayValue}
                        showAddress={showAddress}
                        paymentAddress={paymentAddress}
                        coolingOffPeriod={coolingOffPeriod}
                        showFxRate={showFxRate}
                        fxRate={fxRate}
                        showTotalPayerAmount={showTotalPayerAmount}
                        payerCurrency={payerCurrency}
                        totalPayerAmount={totalPayerAmount}
                    />
                )}

                <Grid container>
                    <Box maxWidth='600px' marginBottom={['10px', '10px', '10px', '10px']} marginTop={['10px', '10px', '10px', '24px']}>
                        <Typography variant='body1'>{t('verifyDetailsConfirm.ifTheAboveDetails')}</Typography>
                    </Box>
                </Grid>

                <Grid container md={12}>
                    <Box
                        marginTop={2}
                        display='flex'
                        flexDirection='row'
                        justifyContent='space-between'
                        width='100%'
                        maxWidth='600px'
                        paddingTop={['1em', '1em', '1em', '1em']}
                        borderTop='1px solid #333'
                    >
                        <Button
                            id='verify-button-cancel'
                            variant='light.tertiary'
                            onClick={() => {
                                history.push('payments-list-guest');
                            }}
                        >
                            {t('verifyDetailsConfirm.cancel')}
                        </Button>
                        <Button
                            id='verify-button-continue'
                            variant='light.primary'
                            onClick={() => {
                                confirmDetails();
                            }}
                        >
                            {t('verifyDetailsConfirm.continue')}
                        </Button>
                    </Box>
                </Grid>
            </Grid>
        </VerifyDetailsConfirmPlaceholder>
    );
};

export default VerifyDetailsConfirm;
